import React from 'react';
import styled from 'styled-components';

const FooterContainer = styled.div`
  background-color: #f2f2f2;
  padding: 20px;
  text-align: center;
`;

const Footer = () => {
  return (
    <FooterContainer>
      <p>Footer</p>
    </FooterContainer>
  );
};

export default Footer;
